import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import az from './locales/az.json';
import ru from './locales/ru.json';
import en from './locales/en.json';

export const supportedLanguages = ['az', 'ru', 'en'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const languageNames: Record<SupportedLanguage, string> = {
  az: 'AZ',
  ru: 'RU',
  en: 'EN',
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      az: { translation: az },
      ru: { translation: ru },
      en: { translation: en },
    },
    fallbackLng: 'az',
    supportedLngs: [...supportedLanguages],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'cm_lang',
    },
  });

// Mirror resolved language onto <html lang> (index.html defaults to "en")
// so screen readers don't voice AZ/RU content as English; LanguageSelector
// keeps it in sync after boot.
if (typeof document !== 'undefined') {
  const apply = () => {
    document.documentElement.lang = i18n.resolvedLanguage || i18n.language || 'az';
  };
  apply();
  i18n.on('languageChanged', apply);
}

export default i18n;
